import { defineAsyncComponent } from 'vue';

/** Lazy-load a single-file Vue component only when it is rendered in the DOM. */
export function asyncView(loader) {
    return defineAsyncComponent(() => loader().then((module) => module.default));
}
